import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import AppTabs from '../../../components/designe/app-tabs/AppTabs';
import PageContainer from '../../../components/layout/page-container/PageContainer';
import { usePullRefreshInvalidateTags } from '../../../hooks/usePullRefreshInvalidateTags';
import { usersApi } from '../../../redux/api/users/usersApi';
import { USERS } from '../../../redux/constants';
import { Paths } from '../../../shared/paths';
import { useStyles } from './Users.styles';

export default function Users(props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { onRefresh } = usePullRefreshInvalidateTags([
    {
      apiSlice: usersApi,
      tags: [
        USERS.USERS,
        USERS.ME,
        USERS.USER_SUBSCRIBERS,
        USERS.USER_SUBSCRIPTIONS,
        USERS.USER_SUBSCRIBER_REQUESTS,
        USERS.REJECTED_USER_SUBSCRIBER_REQUESTS,
      ],
    },
  ]);

  const tabsConfig = [
    { label: t('users.allUsers'), path: Paths.users.toList },
    {
      label: t('users.subscriptions'),
      path: Paths.users.toSubscriptions,
    },
    {
      label: t('users.subscribers'),
      path: Paths.users.toSubscribers,
    },
    {
      label: t('users.requests'),
      path: Paths.users.toRequests,
    },
  ];

  return (
    <PageContainer title={t('common.users')} onRefresh={onRefresh}>
      <>
        <AppTabs config={tabsConfig} />
        <Box className={classes.tabsContent}>
          <Outlet />
        </Box>
      </>
    </PageContainer>
  );
}
